import FullGridDarkTemplate from './FullGridDarkTemplate';
import FullGridLightTemplate from './FullGridLightTemplate';
import FullGridDarkMobileTemplate from './FullGridDarkMobileTemplate';
import FullGridLightMobileTemplate from './FullGridLightMobileTemplate';
import MultiDayDarkTemplate from './MultiDayDarkTemplate';
import MultiDayLightTemplate from './MultiDayLightTemplate';

/**
 * Template id (AVAILABILITY_IMAGE_TEMPLATES in bookingConst.js) → component.
 * Adding a template means a new component here plus an entry in that list;
 * the modal renders whatever the list names. The mobile components serve
 * both phone sizes — the list's `format` ('story' / 'portrait') picks one —
 * and each design is listed twice, the list's `rowMode` choosing per-hour
 * rows or time ranges. The multiDay* ids are the date-range images
 * (AVAILABILITY_IMAGE_MULTI_DAY_TEMPLATES), rendered from a
 * buildMultiDaySnapshot() snapshot: the phone sizes reuse the mobile
 * components (which switch to the compact days-across table), the wide size
 * has its own.
 */
export const AVAILABILITY_TEMPLATE_COMPONENTS = {
  fullGridDark: FullGridDarkTemplate,
  fullGridLight: FullGridLightTemplate,
  fullGridDarkStory: FullGridDarkMobileTemplate,
  fullGridLightStory: FullGridLightMobileTemplate,
  fullGridDarkPortrait: FullGridDarkMobileTemplate,
  fullGridLightPortrait: FullGridLightMobileTemplate,
  fullGridDarkHourly: FullGridDarkTemplate,
  fullGridLightHourly: FullGridLightTemplate,
  fullGridDarkStoryHourly: FullGridDarkMobileTemplate,
  fullGridLightStoryHourly: FullGridLightMobileTemplate,
  fullGridDarkPortraitHourly: FullGridDarkMobileTemplate,
  fullGridLightPortraitHourly: FullGridLightMobileTemplate,
  multiDayDarkStory: FullGridDarkMobileTemplate,
  multiDayLightStory: FullGridLightMobileTemplate,
  multiDayDarkStoryHourly: FullGridDarkMobileTemplate,
  multiDayLightStoryHourly: FullGridLightMobileTemplate,
  multiDayDarkPortrait: FullGridDarkMobileTemplate,
  multiDayLightPortrait: FullGridLightMobileTemplate,
  multiDayDarkPortraitHourly: FullGridDarkMobileTemplate,
  multiDayLightPortraitHourly: FullGridLightMobileTemplate,
  multiDayDark: MultiDayDarkTemplate,
  multiDayLight: MultiDayLightTemplate,
  multiDayDarkHourly: MultiDayDarkTemplate,
  multiDayLightHourly: MultiDayLightTemplate,
};
